/**
 * Deze klasse zorgt voor het tonen van een text entry
 *
 * @history
 * 9 augustus 2022
 * Basis implementatie
 *
 */
import React from "react";

export class LogTextEntry extends React.Component {
    constructor(props) {
        super(props);

        console.log(this.props.log);
    }

    nl2br (str, is_xhtml) {
        if (typeof str === 'undefined' || str === null) {
            return '';
        }
        var breakTag = (is_xhtml || typeof is_xhtml === 'undefined') ? '<br />' : '<br>';
        return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }

    render() {
        return (
            <div className={"logger__entry__wrapper"}>
                {this.props.log.title != "" &&
                    (
                        <h3>{this.props.log.title}</h3>
                    )}

                <p dangerouslySetInnerHTML={{__html:this.nl2br(this.props.log.data)}}></p>
                <a href="javascript:void(0)"  onClick={() => this.props.edit_callback(this.props.log_index, "text")} className="logger_button"><img src={"/digibord/assets/svgs/ui/pencil_white.svg"} className={"ui_icon"}/></a>
                <a href="javascript:void(0)"  onClick={() => this.props.delete_callback(this.props.log_index)} className="logger_button"><img src={"/digibord/assets/svgs/ui/trash_white.svg"} className={"ui_icon"}/></a>
                <br/>

            </div>

        );
    }

}
